import React, { useEffect, useRef, useState } from "react";
import "./StaffList.scss";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { useQuery } from "@tanstack/react-query";
import {
  ActivateUser,
  DeactivateUser,
  UserResetPassword,
  deleteStaff,
  getSignupReDetail,
  getUser,
  listStaff,
} from "../../../../apiCall";
import toast from "react-hot-toast";
import {
  formatDateTimetoAmPm,
  FormateDate,
} from "../../../../utils/FormateDate";
import { NewPasswordModal } from "../../../../components/Modals/NewPasswordModal";
import { ConfirmationModal } from "../../../../components/Modals/ConfirmationModal";
import { useStateValue } from "../../../../StateProvider";
import { IoMdSearch } from "react-icons/io";

const StaffList = ({
  setActiveTab,
  setEditUserData,
  userTypeOption,
  handleConfirmationShow,
  setFunHandler,
  newAddedStaff,
  newUpdatedStaff,
  setNewAddedStaff,
  setNewUpdatedStaff,
  setIsStaffDetailRefetch,
  isStaffDetailRefetch,
}) => {
  const [{ sysConfig }, dispatch] = useStateValue();
  const searchInputWeb = useRef(null);
  const searchInputMobile = useRef(null);
  const activeUser = async (id) => {
    const re = await ActivateUser(id);
    if (re?.status === 200) {
      toast.success("success");
      refetch();
    } else if (re?.response) {
      toast.error("somthing went wrong.");
    }
  };
  const deactivateUser = async (id) => {
    const re = await DeactivateUser(id);
    if (re?.status === 200) {
      toast.success("success");
      refetch();
    } else if (re?.response) {
      toast.error("somthing went wrong.");
    }
  };
  const resetPassword = async (id) => {
    const re = await UserResetPassword(id);
    if (re?.status === 200) {
      toast.success("success");
      setNewPassword(re.data.status.new_password);
      handleShow();
      refetch();
    } else if (re?.response) {
      toast.error("somthing went wrong.");
    }
  };
  const fetchStaffList = async () => {
    // Perform the API call to fetch company info
    try {
      const response = await listStaff();
      if (response?.status === 200) {
        setStaffList(response.data);
        setFilteredData(response.data);
        setIsStaffDetailRefetch(false);

        // refetch();
      } else if (response?.response?.status) {
        toast.error("Something went wrong.");
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const deleteUser = async (userId) => {
    // Perform the API call to fetch company info
    try {
      const response = await deleteStaff(userId);
      console.log(response);
      if (response?.status === 200) {
        if (response.data.status !== "account_not_found") {
          toast.success(response.data.status);
          refetch();
        } else if (response?.response) {
          toast.error(response.data.status);
        }
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };

  const {
    isLoading,
    isFetching,
    data: staffListData,
    refetch,
  } = useQuery({
    queryKey: ["staff-list"],
    queryFn: () => fetchStaffList(),
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [staffList, setStaffList] = useState([]);

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [isActiveFilter, setIsActiveFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    filterData(searchQuery, typeFilter, isActiveFilter);
    setCurrentPage(1);
  }, [searchQuery, typeFilter, isActiveFilter]);

  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );
  }, [currentPage, filteredData, sysConfig]);

  useEffect(() => {
    filterData(searchQuery, typeFilter, isActiveFilter);
    setTotalPages(
      Math.ceil(
        filteredData.length / Number(sysConfig["Rows in MultiLine List"])
      )
    );
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [staffList, sysConfig]);

  useEffect(() => {
    if (newUpdatedStaff?.Code) {
      const targetIndex = filteredData.findIndex(
        (item) => item.Code === newUpdatedStaff.Code
      );
      const pageNumber =
        Math.floor(targetIndex / Number(sysConfig["Rows in MultiLine List"])) +
        1;
      console.log("page number", filteredData, targetIndex, pageNumber);
      setCurrentPage(pageNumber);
    }
  }, [newUpdatedStaff, filteredData, sysConfig]);

  useEffect(() => {
    if (newAddedStaff?.Code) {
      const targetIndex = filteredData.findIndex(
        (item) => item.Code === newAddedStaff.Code
      );
      const pageNumber =
        Math.floor(targetIndex / Number(sysConfig["Rows in MultiLine List"])) +
        1;
      console.log("page number", filteredData, targetIndex, pageNumber);
      setCurrentPage(pageNumber);
    }
  }, [newAddedStaff, filteredData, sysConfig]);

  const setDefaultValue = () => {
    setNewAddedStaff({});
    setNewUpdatedStaff({});
  };

  const handleTypeChange = (e) => {
    const type = e.target.value;
    setTypeFilter(type);
    setDefaultValue();
  };

  const handleIsActiveChange = (e) => {
    const isActive = e.target.value;
    setIsActiveFilter(isActive);
    setDefaultValue();
  };
  const handleSearch = (e) => {
    let query;
    if (window.innerWidth >= 767) {
      query = searchInputWeb.current.value.toLowerCase();
    } else {
      query = searchInputMobile.current.value.toLowerCase();
    }
    setSearchQuery(query);
    setDefaultValue();
  };
  const filterData = (query, type, isActive) => {
    let filtered = staffList;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Code.toLowerCase().includes(query) ||
          item.Name.toLowerCase().includes(query) ||
          item.Mobile.includes(query)
      );
    }

    if (type) {
      filtered = filtered.filter((item) => item.Type.textval === type);
    }

    if (isActive) {
      const isActiveBool = isActive === "true";

      filtered = filtered.filter((item) => item.IsActive === isActiveBool);
    }
    if (buttonRef.current && isFilterOpen && filtered.length > 0) {
      buttonRef.current.click();
    }
    if (buttonRef.current && isFilterOpen && filtered.length > 0) {
      buttonRef.current.click();
    }
    setFilteredData(filtered);
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setDefaultValue();
  };

  // const [staffList, setStaffList] = useState(staffListData?.status === 200 ?staffListData?.data:[]);

  // ************************************************************* reset password modal **********************************

  const [show, setShow] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const handleClose = () => {
    setShow(false);
    setNewPassword("");
  };
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (isStaffDetailRefetch) {
      refetch();
    }
  }, [isStaffDetailRefetch]);

  // ****************************************** accordion start *********************************************
  const statusTitle = (status, projectType) => {
    if (projectType === "over_due") {
      return "List of Over due Project";
    } else if (status === "1" || projectType === "up_coming") {
      return "List of Up Coming Project";
    } else if (status === "2" || projectType === "on_going") {
      return "List of On Going Project";
    } else if (status === "3" || projectType === "under_review") {
      return "List of Under Review Project";
    } else if (status === "4") {
      return "List of Completed Project";
    } else if (status === "5") {
      return "List of Cancelled Project";
    } else {
      return "List of Project";
    }
  };
  const [isFilterOpen, setIsFilterOpend] = useState(true);
  const collapseRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    // Ensure the ref points to the correct element
    const collapseElement = collapseRef.current;

    // Event listener for when the accordion is opened
    const handleShown = () => {
      console.log("Accordion is opened");
      setIsFilterOpend(true);
    };

    // Event listener for when the accordion is closed
    const handleHidden = () => {
      setIsFilterOpend(false);

      console.log("Accordion is closed");
    };

    // Attach event listeners for Bootstrap collapse events
    collapseElement.addEventListener("shown.bs.collapse", handleShown);
    collapseElement.addEventListener("hidden.bs.collapse", handleHidden);

    // Cleanup listeners when component unmounts
    return () => {
      collapseElement.removeEventListener("shown.bs.collapse", handleShown);
      collapseElement.removeEventListener("hidden.bs.collapse", handleHidden);
    };
  }, []);
  // ****************************************** accordion end *********************************************
  // ****************************************** accordion close when click outside start *********************************************
  const handleClickOutside = (event) => {
    if (
      collapseRef.current &&
      !collapseRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      const collapseInstance = new window.bootstrap.Collapse(
        collapseRef.current,
        {
          toggle: false,
        }
      );
      collapseInstance.hide();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // ****************************************** accordion close when click outside end *********************************************
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area">
        <div className="container-fluid">
          <div className="row web-view">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              <div className="mb-5">
                <h3 className="mb-0 ">List of Staff</h3>
              </div>
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-12">
                {/* card */}
                <div className="card mb-4">
                  <div
                    className="accordion position-absolute w-100 z-3 mobile-view"
                    id="accordionExample"
                  >
                    <div className="accordion-item">
                      <h2 className="accordion-header bg-white" id="headingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          ref={buttonRef}
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          <strong>List of Staff</strong>
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        ref={collapseRef}
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="card-header  ">
                          <div className="row ">
                            <div className=" mb-3 d-flex justify-content-end ">
                              <div
                                className="btn btn-primary  col-lg-3 col-md-4 col-12"
                                onClick={() => setActiveTab("addStaff")}
                              >
                                + Add Staff
                              </div>
                            </div>
                          </div>
                          <>
                            <div className="row justify-content-between">
                              <div className=" col-lg-4 col-md-6 mt-md-3 d-flex">
                                <input
                                  type="search"
                                  className="form-control "
                                  // value={searchQuery}
                                  // onChange={handleSearch}
                                  onChange={(e) => {
                                    if (e.target.value === "") {
                                      handleSearch();
                                    }
                                  }}
                                  ref={searchInputMobile}
                                  placeholder="Search for code, name or mobile."
                                />
                                <div
                                  className="btn btn-primary ms-3"
                                  onClick={() => handleSearch()}
                                >
                                  <IoMdSearch size={25} />
                                </div>
                              </div>

                              <div className="col-lg-4 col-md-6  mt-3 mt-md-3">
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={typeFilter}
                                  onChange={handleTypeChange}
                                >
                                  <option selected="" value="">
                                    All Types
                                  </option>
                                  {userTypeOption.map((item) => (
                                    <option value={item.value}>
                                      {item.value}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-4 col-md-6  mt-3 mt-md-3">
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  value={isActiveFilter}
                                  onChange={handleIsActiveChange}
                                >
                                  <option selected="" value={""}>
                                    All Status
                                  </option>
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-header web-view  ">
                    <div className="row ">
                      <div className=" mb-3 d-flex justify-content-end ">
                        <div
                          className="btn btn-primary  col-lg-3 col-md-4 col-12"
                          onClick={() => setActiveTab("addStaff")}
                        >
                          + Add Staff
                        </div>
                      </div>
                    </div>
                    <>
                      <div className="row justify-content-between">
                        <div className=" col-lg-4 col-md-6 mt-md-3 d-flex">
                          <input
                            type="search"
                            className="form-control "
                            // value={searchQuery}
                            // onChange={handleSearch}
                            onChange={(e) => {
                              if (e.target.value === "") {
                                handleSearch();
                              }
                            }}
                            ref={searchInputWeb}
                            placeholder="Search for code, name or mobile."
                          />
                          <div
                            className="btn btn-primary ms-3"
                            onClick={() => handleSearch()}
                          >
                            <IoMdSearch size={25} />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6  mt-3 mt-md-3">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            value={typeFilter}
                            onChange={handleTypeChange}
                          >
                            <option selected="" value="">
                              All Types
                            </option>
                            {userTypeOption.map((item) => (
                              <option value={item.value}>{item.value}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-4 col-md-6  mt-3 mt-md-3">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                            value={isActiveFilter}
                            onChange={handleIsActiveChange}
                          >
                            <option selected="" value={""}>
                              All Status
                            </option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </>
                  </div>
                  {!isFetching ? (
                    <>
                      <div className="card-body">
                        <div className="table-responsive table-card">
                          {currentItems.length > 0 ? (
                            <table className="table text-nowrap responsive-table main-table mb-0 table-centered table-hover">
                              <thead className="table-light">
                                <tr>
                                  <th className=" pe-0  ">Code</th>
                                  <th className="ps-1">Name</th>
                                  <th>Mobile</th>
                                  <th>Type</th>
                                  <th>DOB</th>
                                  <th>Last Login</th>
                                  <th>Password</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                {currentItems.map((user, index) => (
                                  <tr
                                    id={`user-${index}`}
                                    className={`${
                                      newUpdatedStaff?.Code === user?.Code ||
                                      newAddedStaff?.Code === user?.Code
                                        ? "table-primary"
                                        : ""
                                    }`}
                                  >
                                    <td data-label1="Code">{user?.Code}</td>
                                    <td data-label1="Name" className="ps-1">
                                      <div className="d-flex align-items-center">
                                        <div>
                                          {user?.Photo ? (
                                            <img
                                              src={user?.Photo}
                                              alt="Imagde"
                                              className="avatar avatar-sm rounded-circle"
                                            />
                                          ) : (
                                            <>
                                              {user?.Gender?.textval ===
                                              "Male" ? (
                                                <img
                                                  alt="avatar"
                                                  src="./assets/images/avatar/male.jpg"
                                                  className="avatar avatar-sm rounded-circle"
                                                />
                                              ) : (
                                                <img
                                                  alt="avatar"
                                                  src="./assets/images/avatar/female.jpg"
                                                  className="avatar avatar-sm rounded-circle"
                                                />
                                              )}
                                            </>
                                          )}
                                        </div>
                                        <div className="ms-2">
                                          <h5 className="mb-0">
                                            <div className="text-inherit">
                                              {user?.Name}
                                            </div>
                                          </h5>
                                        </div>
                                      </div>
                                    </td>
                                    <td data-label1="Mobile">{user?.Mobile}</td>
                                    <td data-label1="Type">
                                      {user?.Type.textval}
                                    </td>
                                    <td data-label1="DOB">
                                      {FormateDate(user?.BirthDt)}
                                    </td>
                                    <td data-label1="Last Login">
                                      {formatDateTimetoAmPm(user?.LstLoginDtTm)}
                                    </td>
                                    <td data-label1="Password">
                                      {user?.ResetPswd === false
                                        ? "Set"
                                        : "Reset"}
                                    </td>
                                    <td data-label1="Status">
                                      {user?.LockAcnt > 4 ? (
                                        <>
                                          <span className="badge  badge-danger-soft text-danger">
                                            Locked
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          {user?.IsActive ? (
                                            <span className="badge badge-success-soft text-success">
                                              Active
                                            </span>
                                          ) : (
                                            <span className="badge  badge-danger-soft text-danger">
                                              Inactive
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td data-label1="Action" className="d-flex">
                                      <div className="d-flex">
                                        <div
                                          className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                          data-template="editOne"
                                          onClick={() => {
                                            setEditUserData(user);
                                            setActiveTab("updateStaff");
                                            setDefaultValue();
                                          }}
                                        >
                                          <FaRegEdit size={18} />
                                          <div id="editOne" className="d-none">
                                            <span>Edit</span>
                                          </div>
                                        </div>
                                        <div
                                          className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip"
                                          data-template="trashOne"
                                          onClick={() => {
                                            handleConfirmationShow();
                                            setDefaultValue();

                                            setFunHandler({
                                              fun: deleteUser,
                                              id: user?.LoginId,
                                              title: "delete user",
                                            });
                                          }}
                                        >
                                          <MdOutlineDelete size={18} />
                                          <div id="trashOne" className="d-none">
                                            <span>Delete</span>
                                          </div>
                                        </div>
                                        <div className="dropdown">
                                          {/* <button
                                  className="btn btn-secondary dropdown-toggle"
                                  type="button"
                                  id="dropdownMenuButton"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                > */}
                                          <div
                                            type="button"
                                            id="dropdownMenuButton"
                                            data-bs-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            className="btn btn-ghost btn-icon btn-sm rounded-circle texttooltip dropdown-toggle"
                                            data-template="trashOne"
                                          >
                                            <BsThreeDots size={18} />
                                            {/* <div id="trashOne" className="d-none">
                                      <span>Delete</span>
                                    </div> */}
                                          </div>
                                          {/* </button> */}
                                          <div
                                            className="dropdown-menu"
                                            aria-labelledby="dropdownMenuButton"
                                          >
                                            {user?.IsActive ? (
                                              <div
                                                className="dropdown-item"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  handleConfirmationShow();
                                                  setDefaultValue();

                                                  setFunHandler({
                                                    fun: deactivateUser,
                                                    id: user?.LoginId,
                                                    title: "deactive user",
                                                  });
                                                }}
                                              >
                                                Deactivate
                                              </div>
                                            ) : (
                                              <div
                                                className="dropdown-item"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                  handleConfirmationShow();
                                                  setDefaultValue();

                                                  setFunHandler({
                                                    fun: activeUser,
                                                    id: user?.LoginId,
                                                    title: "active user",
                                                  });
                                                }}
                                              >
                                                Activate
                                              </div>
                                            )}
                                            <div
                                              className="dropdown-item"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                handleConfirmationShow();
                                                setDefaultValue();

                                                setFunHandler({
                                                  fun: resetPassword,
                                                  id: user?.LoginId,
                                                  title: "reset user password",
                                                });
                                              }}
                                            >
                                              Reset Password
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <div
                              className={` fs-3 ${
                                isFilterOpen ? "show-margin" : "hidden-margin"
                              }`}
                            >
                              <strong>No records found.!</strong>
                            </div>
                          )}
                        </div>
                      </div>
                      {filteredData.length > 0 && (
                        <div className="card-footer d-md-flex justify-content-between align-items-center">
                          <span>
                            Showing{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) -
                              Number(sysConfig["Rows in MultiLine List"]) +
                              1}{" "}
                            to{" "}
                            {currentPage *
                              Number(sysConfig["Rows in MultiLine List"]) >=
                            filteredData.length
                              ? filteredData.length
                              : currentPage *
                                Number(
                                  sysConfig["Rows in MultiLine List"]
                                )}{" "}
                            of {filteredData.length} entries
                          </span>
                          <nav className="mt-2 mt-md-0">
                            <ul className="pagination mb-0 ">
                              <li
                                className="page-item "
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (currentPage > 1) {
                                    handlePageChange(currentPage - 1);
                                  }
                                }}
                              >
                                <div className="page-link">Previous</div>
                              </li>
                              {Array(totalPages ? totalPages : 0)
                                .fill()
                                .map((item, index) => (
                                  <li
                                    style={{ cursor: "pointer" }}
                                    className={`${
                                      currentPage === index + 1
                                        ? "page-item active"
                                        : "page-item"
                                    }`}
                                    onClick={() => handlePageChange(index + 1)}
                                  >
                                    <div className="page-link">{index + 1}</div>
                                  </li>
                                ))}

                              {/* <li className="page-item">
                            <a className="page-link" href="#!">
                              2
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#!">
                              3
                            </a>
                          </li> */}
                              <li className="page-item">
                                <div
                                  style={{ cursor: "pointer" }}
                                  className="page-link"
                                  onClick={() => {
                                    if (totalPages > currentPage) {
                                      handlePageChange(currentPage + 1);
                                    }
                                  }}
                                >
                                  Next
                                </div>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>Fetching records..</strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewPasswordModal
        show={show}
        onHide={handleClose}
        newPassword={newPassword}
        title="New Password"
      />
    </div>
  );
};

export default StaffList;
